export const blockIconsContentContentCopy = (
	<span className='material-symbols-outlined'>content_copy</span>
);
